// extracted by mini-css-extract-plugin
export default {"maindiv":"service_maindiv__81tUu","springimage":"service_springimage__qqnd+"};